import { Field, FastField } from 'formik';

import { BaseInput } from '../BaseInput/BaseInput';

export const InputField = ({ name, label, disabled = false }) => {
  // const Component = disabled !== undefined ? Field : FastField;
  // return <Component component={BaseInput} name={name} label={label} disabled={disabled} data-testid={name} />;
  return <Field component={BaseInput} name={name} label={label} disabled={disabled} data-testid={name} />;
};

export default InputField;
